import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../config";
import { SubmitButton } from "../../components/Input";
import { showToast } from "../../components/toast";

const EditMediaUpload = () => {
  const { id } = useParams();
  const [file, setFile] = useState(null);
  const [path, setPath] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}media-upload/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (response.data.status) {
          const { path: mediaPath, name: mediaName } = response.data.data;
          setPath(mediaPath || "");
          setName(mediaName || "");
        } else {
          showToast.error("Failed to fetch media details");
          navigate("/Settings/MediaUpload");
        }
      } catch (err) {
        showToast.error("Error fetching data");
        navigate("/Settings/MediaUpload");
      } finally {
        setFetching(false);
      }
    };
    fetchData();
  }, [id, token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!path || !name) {
      showToast.error("Please provide path and name");
      return;
    }

    const formData = new FormData();
    if (file) {
      formData.append("file", file);
    }
    formData.append("path", path);
    formData.append("name", name);

    try {
      setLoading(true);
      const response = await axios.put(`${API_URL}media-upload/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data.status) {
        showToast.success(response.data.message || "Media updated successfully");
        navigate("/Settings/MediaUpload");
      } else {
        showToast.error(response.data.message || "Failed to update");
      }
    } catch (err) {
      showToast.error(err.response?.data?.message || err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="panel panel-default with-rounded-corner with-shadow mt-5">
      <div className="panel-heading border-0">
        <span className="panel-title">Edit Media Upload</span>
      </div>
      <div className="panel-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-2">
              <label className="control-label">Upload File (Leave empty to keep existing)</label>
              <input
                type="file"
                className="form-control"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </div>
            <div className="col-md-6 mb-2">
              <label className="control-label">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="col-md-6 mb-2">
              <label className="control-label">Path</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter path"
                value={path}
                onChange={(e) => setPath(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              <SubmitButton
                pageBack={"/Settings/MediaUpload"}
                handleSubmit={handleSubmit}
                loading={loading}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditMediaUpload;
